import { __rest } from './../../external/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { ChevronDownOutline } from '@olist/design-system-icons';
import { useSelect, clearFilteredOptions, searchOptions } from './SelectContext.js';
import { Input } from '../Input/Input.js';
import '../Input/InputBody.js';
import '../Input/InputPassword/styles.js';

const SelectInput = forwardRef((_a, ref) => {
    var { label, id, isInputFocused, onFocus, onChange, handleFocus: handleInputFocus } = _a, props = __rest(_a, ["label", "id", "isInputFocused", "onFocus", "onChange", "handleFocus"]);
    const [{ searchedTerm, options }, dispatch] = useSelect();
    const selectedOptionsText = options
        .filter((option) => option.selected)
        .map((option) => option.text);
    const hasLessThanThreeSelectedOptions = selectedOptionsText.length < 3;
    const closedInputValue = hasLessThanThreeSelectedOptions
        ? selectedOptionsText.join(', ')
        : `${selectedOptionsText.length} itens`;
    const inputValue = isInputFocused ? searchedTerm : closedInputValue;
    const handleInputChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        if (!event.target.value) {
            clearFilteredOptions(dispatch);
            searchOptions(dispatch, '');
            return;
        }
        searchOptions(dispatch, event.target.value);
    };
    const handleFocus = (event) => {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        if (selectedOptionsText.length) {
            searchOptions(dispatch, '');
        }
    };
    return (React.createElement(Input, Object.assign({}, props, { ref: ref, label: label, id: id, suffix: React.createElement(ChevronDownOutline, { "aria-hidden": true, onClick: handleInputFocus }), onChange: handleInputChange, onFocus: handleFocus, value: inputValue, autoComplete: "off", style: { textOverflow: 'ellipsis' } })));
});
SelectInput.displayName = 'SelectInput';

export { SelectInput };
